// Campaña estática temporal de Cyberweek.
// Se usa en la web pública mientras no esté implementado el backend de
// campañas (ver PLAN-campanas-descuento-backend-2026-11-02.md).
export interface PreviewProduct {
  kind: 'nuevo' | 'usado';
  id?: string;
  model: string;
  gama: string;
  storage?: string;
  price: number;
}

export interface PreviewRule {
  id: string;
  label: string;
  type: 'monto' | 'porcentaje';
  value: number;
  scope: 'nuevo' | 'usado' | 'todos';
  models?: string[];
  usedIds?: string[];
  priority: number;
}

export interface PreviewDiscount {
  label: string;
  ruleId: string;
  base: number;
  discount: number;
  final: number;
  until: string;
}

export const PREVIEW_CAMPAIGN = {
  label: 'CYBERWEEK',
  text: 'Descuentos en todos nuestros equipos',
  until: '2026-11-08',
  rules: [
    { id: 'new-10', label: 'CYBERWEEK', type: 'monto', value: 10, scope: 'nuevo', priority: 10 },
    { id: 'used-10', label: 'CYBERWEEK', type: 'monto', value: 10, scope: 'usado', priority: 10 },
  ] as PreviewRule[],
};

function normalize(value: unknown): string {
  return String(value ?? '').trim().toLowerCase();
}

export function previewDiscount(product: PreviewProduct): PreviewDiscount | null {
  const base = Number(product.price) || 0;
  if (base <= 0) return null;
  const candidates = PREVIEW_CAMPAIGN.rules
    .filter((rule) => rule.scope === 'todos' || rule.scope === product.kind)
    .filter((rule) => !rule.models?.length || rule.models.some((m) => normalize(m) === normalize(product.model)))
    .filter((rule) => !rule.usedIds?.length || product.kind !== 'usado' || rule.usedIds.map(String).includes(String(product.id)))
    .map((rule) => {
      const raw = rule.type === 'porcentaje' ? base * rule.value / 100 : rule.value;
      const discount = Math.round(raw);
      const final = base - discount;
      return final >= 1 ? { rule, discount, final } : null;
    })
    .filter((x): x is { rule: PreviewRule; discount: number; final: number } => !!x)
    .sort((a, b) => (b.rule.priority - a.rule.priority) || (b.discount - a.discount));

  const winner = candidates[0];
  if (!winner) return null;
  return {
    label: winner.rule.label,
    ruleId: winner.rule.id,
    base,
    discount: winner.discount,
    final: winner.final,
    until: PREVIEW_CAMPAIGN.until,
  };
}
